import {Component, OnInit} from '@angular/core';
import {SubcategoryService} from '../services/subcategory.service';
import {MemberService} from '../services/member.service';
import {SubcategoryHistoryService} from '../services/subcategory-history.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {FileService} from '../services/file.service';

@Component({
  selector: 'app-reports-category',
  templateUrl: './reports-category.component.html',
  styleUrls: [ './reports-category.component.scss' ]
})
export class ReportsCategoryComponent implements OnInit {

  public arrayCategory = [];
  public partners = [];
  public members = [];
  public histories = [];

  constructor (
    private _subcategoryService: SubcategoryService,
    private _memberService: MemberService,
    private _subcategoryHistoryService: SubcategoryHistoryService,
    private _spinnerService: SpinnerService,
    private _fileService: FileService,
  ) {
    this.loads()
  }

  ngOnInit () {
  }

  async loads () {
    const waiting = this._spinnerService.show();

    this.partners = await this._subcategoryService.selectPartners();
    this.members = await this._memberService.selectWithCategories();
    this.histories = await this._subcategoryHistoryService.loadAllHistories();

    this.arrayCategory = []
    let arrayCat = []

    arrayCat.push("Nome")
    this.partners.forEach(partner => {
      arrayCat.push(partner.name)
    })
    this.arrayCategory.push(arrayCat)

    for (let idx = 0; idx < this.members.length; idx++) { // 
      arrayCat = []

      const member = this.members[ idx ];

      arrayCat.push(member.name)

      this.partners.forEach(partner => {

        const exist = this.histories.find((e) => {
          return e.member_id == member.id && e.category_id == partner.id
        })

        if (exist) {
          arrayCat.push(exist.date);
        } else {
          arrayCat.push("");
        }
      });

      this.arrayCategory.push(arrayCat)
    }

    //  console.log(JSON.stringify(this.arrayCategory))

    this.partners = null;
    this.members = null;
    this.histories = null;

    waiting.close();
  }

  async exportToCSV () {
     const waiting = this._spinnerService.show();
     
    const data = this.arrayCategory
    const csvContent = data.map((element: any) => {
      const item = element;
      return Object.values(item).join(';');
    });

    const csvArray = [ ...csvContent ].join('\n');
    const blob = new Blob([ `\uFEFF${ csvArray }` ], {type: 'text/csv;charset=utf-8;'});
    this._fileService.saveFile(blob,  "Historico_Categorias.csv");

    waiting.close();
  };

}
